import React from 'react';

import { Select } from '@aline/common';
import { Typography } from '@mui/material';
import type { GridCellParams } from '@mui/x-data-grid-premium';
import type { StorableIconDocument } from 'src/components';
import { AlineTooltip, StorableIcon } from 'src/components';
import { FavoriteStarIcon } from 'src/components/icons/FavoriteStarIcon';
import { IconColors } from 'src/components/icons/icon-utils';
import type { Apollo } from 'src/gql/generated';
import { createClampStyles } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

const useNameStyles = makeStyles()(theme => ({
  cell: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    // Needed for ellipse to work on noWrap text.
    width: '100%',
  },
  name: {
    ...createClampStyles(2),
  },
}));

interface DocumentRow
  extends
    StorableIconDocument,
    Pick<Apollo.Document, 'name' | 'isCommunityTemplate' | 'requesterFavorited' | '__typename'> {
  id: UUID;
  workflow: Pick<Apollo.Workflow, 'id' | '__typename'> | null;
}

export function DocumentNameAndBadgeCell({ row }: GridCellParams<DocumentRow>): JSX.Element {
  const { classes } = useNameStyles();
  const name = row?.name || 'Untitled';

  return (
    <div className={classes.cell}>
      <StorableIcon storable={row} />
      <AlineTooltip title={name}>
        <Typography
          className={classes.name}
          data-cy={Select.workflow.detail.documents.documentName}
          variant="subtitle2"
        >
          {name}
        </Typography>
      </AlineTooltip>
      {row.requesterFavorited && <FavoriteStarIcon fill={IconColors.StarYellow} />}
    </div>
  );
}
